import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
const RFQMenu = () => {
 
  return (
    <div > 
      
     <Navbar style={{backgroundColor:"#2F9DCC"}} className='d-flex justify-content-left'>
    
          <Nav>
            <Nav.Link as={Link} to="/Dashboard" className='text-white'>Home</Nav.Link>
             <Nav.Link as={Link} to="/QuotesforIndividual" className='text-white'>Quotes for Individual</Nav.Link>
            <Nav.Link as={Link} to="/QuotesforBusiness" className='text-white'>Quotes for Business </Nav.Link>
            <Nav.Link as={Link} to="/QuotesforAnnuity" className='text-white'>Quotes for Annuity</Nav.Link>
          
          </Nav>
          </Navbar>
    
    </div>
  )
}

export default RFQMenu
